import React from 'react'
import { Container, Grid, Button } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';

import LoadingComponent from "../../../common/LoadingComponent";
import { source } from 'react-aim';
import TextEditor from '../../../common/TextEditor';
import BreadCrumbOrganization from './cards/BreadCrumbOrganization';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name);
    }
})

class AddOrganizationUnit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            description: ""
        }
        this.cancelAddOrg = this.cancelAddOrg.bind(this);
        this.onSubmitAddOrg = this.onSubmitAddOrg.bind(this);
        this.updateText = this.updateText.bind(this)
    }

    /* This is called on cancel button of Add organization form */
    cancelAddOrg(e) {
        e.preventDefault();
        const history = this.props.history;
        dispatch.community.addBreadCrumbOps('');
        dispatch.app.showToolbar(true)
        dispatch.organizationUnit.addSelectedSubOrg(this.props.selectedSubOrg);
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/team/${this.props.match.params.teamId}`,
            state: { onClick: "CANCEL" }
        });

    }

    /* This is called on Add organization form */
    async onSubmitAddOrg(formData) {
        formData.organizationId = this.props.match.params.workspaceId;
        formData.accountId = this.props.match.params.accountId;
        formData.parentOrganizationId = this.props.match.params.teamId;
        formData.name = this.state.name;
        formData.slug = this.state.name.toLowerCase().trim();
        formData.summary = this.state.description;
        formData.members = [{
            role: "Manager",
            accountUserId: this.props.user._id
        }]
        await dispatch.organizationUnit.addSubOrganizationAsync(formData);
        dispatch.app.showToolbar(true)
    }

    componentWillMount() {
        this.getStart();
    }

    async getStart() {
        dispatch.app.showToolbar(false)
        dispatch.organizationUnit.setError(null);
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.organizationUnit.showResourecePane(null);
        dispatch.organizationUnit.showDeleteDisabled(true);
        dispatch.community.addMainAreaContext('ORGANIZATION');
        if (this.props.match.params.workspaceId === this.props.match.params.teamId) {
            await dispatch.organizationUnit.getOrgByIdAsync(this.props.match.params.workspaceId);
        }
        else {
            await dispatch.organizationUnit.getSubOrgByIdAsync(this.props.match.params.teamId);

        }

    }

    componentDidMount() {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.organizationUnit.showResourecePane(null);
    }

    updateText(data, name) {
        if (name.name === "Title") {
            this.setState({ name: name.value })
        } else if (name === "Description") {
            this.setState({ description: data })
        }
    }


    render() {
        const { addSubOrgloading } = this.props;

        return (
            <div >
                <BreadCrumbOrganization {...this.props} />
                <LoadingComponent active={addSubOrgloading} message="loading..." />
                <Form noValidate
                    className="invitationForm"
                    ref={ref => this.form = ref}
                    onValidSubmit={this.onSubmitAddOrg}
                >
                    <Form.Input
                    required
                        name="Title"
                        label="Title"
                        value={this.state.name}
                        onChange={this.updateText}
                        id='orgName'
                        instantValidation
                        autoFocus
                    />
                    <br />

                    <TextEditor
                        name="Description"
                        text={this.state.description}
                        type="textarea"
                        onChangeText={this.updateText}
                        id='orgDescription'
                        className='orgDescription'
                    />

                    <span className="actionInFormcy border-none">
                        <Button id="savebtn" type="submit" className="button-submit float-right" >Save</Button>
                        <Button id="cancelbtn" type="button" className="button-cancel float-right" onClick={this.cancelAddOrg}>Cancel</Button>
                    </span>
                </Form>
            </div>
        )
    }
}


export default withRouter(AddOrganizationUnit) 